// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ResearcherList-cls1__f73f7d71f91d1ad58eee{/*!*/}.ResearcherList-cls2___796f40bf48e45702f16{display:flex;overflow:hidden}@media(max-width: 567px){.ResearcherList-cls2___796f40bf48e45702f16{width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ResearcherList-cls1__f73f7d71f91d1ad58eee",
	"cls2": "ResearcherList-cls2___796f40bf48e45702f16 ResearcherList-cls1__f73f7d71f91d1ad58eee"
};
export default ___CSS_LOADER_EXPORT___;
